module.exports=function(scope){ return `<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "No entry found in the database for this enrollmentIdentifier."
    },
    "data": {
        "enrollmentIdentifier": "foo"
    }
}

<!-- Invalid enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "message": "One of the enrollmentIdentifier values was invalid. An enrollmentIdentifier must be a non-empty alphanumeric string. Underscores, hyphens, and emails are also allowed."
    },
    "data": {
        "enrollmentIdentifier": "..."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/failure/enrollment-get-facemap.json.tpl